import React, { useEffect } from 'react'
import FindReplace from './FindReplace'

const FindReplacePopup = ({ textareaRef, showFindReplace, setShowFindReplace, targetSegments, setTargetSegments }) => {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') setShowFindReplace(false);
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
        // eslint-disable-next-line
    }, []);

    console.log('targetSegments:', targetSegments);
    console.log('type:', typeof targetSegments);

    return (
        <div>
            {showFindReplace && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="relative w-[700px] max-w-full">

                        {/* Close button */}
                        <button
                            onClick={() => setShowFindReplace(false)}
                            className="absolute top-2 right-3 bg-gray-50 hover:bg-gray-300 text-black text-xl rounded-full px-4 py-2"
                        >
                            X
                        </button>

                        <FindReplace
                            textareaRef={textareaRef}
                            currentText={targetSegments.join("\n\n")}
                            onTextChange={(newText) => {
                                const updated = newText
                                    .split(/\n\s*\n/)
                                    .map(s => s.trim());

                                setTargetSegments(updated);   // ✅ updates editor instantly
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default FindReplacePopup
